import { gql } from '@apollo/client';
import { queryGeneralData, querySystemAccessData } from '../query/employees';

export const CREATE_EMPLOYEE = gql`
  mutation createEmployee($data: CreateEmployeeInput!) {
    createEmployee(data: $data) {
      id
    }
  }
`;

export const UPDATE_EMPLOYEE = gql`
  mutation updateEmployee($data: UpdateEmployeeInput!) {
    updateEmployee(data: $data) {
      ${queryGeneralData}
    }
  }
`;

export const DELETE_EMPLOYEE = gql`
  mutation deleteEmployee($id: String!) {
    deleteEmployee(id: $id)
  }
`;

export const RESTORE_EMPLOYEE = gql`
  mutation restoreEmployee($id: ID!) {
    restoreEmployee(id: $id) {
      id
    }
  }
`;

export const RESET_EMPLOYEE_PASSWORD = gql`
  mutation resetEmployeePassword($userId: String!) {
    resetEmployeePassword(userId: $userId)
  }
`;

export const EDIT_EMPLOYEE_SYSTEM_DATA = gql`
  mutation editSystemAccessOfUser($data: SystemAccessInput!) {
    editSystemAccessOfUser(data: $data) {
        ${querySystemAccessData}
      }
    }
`;

export const SET_PASSWORD_AND_PIN = gql`
  mutation setPasswordAndPin($data: PasswordAndPinInput!) {
    setPasswordAndPin(data: $data)
  }
`;

export const CREATE_TIMEOS_USER_FOR_EXISTING_EMPLOYEE = gql`
  mutation createTimeosUser($employeeId: String!) {
    createTimeosUser(employeeId: $employeeId) {
      id
      username
    }
  }
`;
